/** Тексты пространства «property». Ключи именуются по смыслу, а не по месту. */
export const property = {
  /** Переключатель состояний: с прописной, это подписи полосы, а не знака. */
  state: {
    published: 'В карточке',
    requests: 'Заявки',
    archived: 'Архив',

    /** Подписи знака состояния — строчными, их читают боковым зрением. */
    badge: {
      rejected: 'отклонена',
      editPending: 'правка в пути',
    },
  },

  /** Что это значит и что делать: у живой вещи объяснять нечего. */
  hint: {
    rejected: 'Причина — в разделе «Решения». Поправьте и отправьте снова.',
    submitted: 'Отправлено {{date}}',
    editPending: 'В карточке персонажа пока прежняя версия. Правка на проверке с {{date}}',
  },

  action: {
    edit: 'Править',
    archive: 'В архив',
  },

  /* ── Подтверждение архивирования ────────────────────────────────────── */
  archive: {
    confirm: 'Отправить {{subject}} в архив?',
    note: 'Из карточки персонажа пропадёт, но сохранится в архиве.',
    reasonPlaceholder: 'Причина, если хотите её оставить',
    submit: 'Да, в архив',
    cancel: 'Оставить',
    noReason: 'Причину не указали.',
  },

  /* ── «Что было в этой версии» ───────────────────────────────────────── */
  version: {
    open: 'Что было в этой версии',
    /** У анкеты раскрывашка показывает правку, а не весь текст версии. */
    changed: 'Что изменилось',
    first: 'Первая версия: сравнивать не с чем, ниже она целиком.',
    same: 'В этой версии текст не менялся.',
    cleared: 'Поле очищено.',
    loading: 'Читаем версию…',
    empty: 'Все поля этой версии пустые.',
  },
} as const;
